import PropTypes from 'prop-types';
import DebugLogger from "../../helpers/DebugLogger";
import { useNavigate, } from "react-router-dom";
import { TOP_LEVEL_NAV_ROUTES } from "../../config/NavRoutes";
import React, { useContext } from "react";
import { CampaignContext } from "../../contexts/CampaignContext";
import "./CampaignSummaryPanel.scss";

import { IconJsxer } from '../../helpers/IconHelper';
import HeadedPanel from "../HeadedPanel/HeadedPanel";
import { countStreamStatusTypesForCampaign, getStatusForCampaign, getStreamTypeDataFromDbString, getTwitchStreamUrl } from '../../helpers/Streams';
import { getRegionDataFromDbString } from '../../helpers/Regions';
import { TwitchIconSvg } from '../../assets/assets';
import { convertMSToHMS, getLongDateString, getShortDateString, getShortDateTimeString, getShortTimeString, getTzLongDateString } from '../../helpers/Dates';
import { CAMPAIGN_TIERS, getCampaignTierDataFromDbString } from '../../helpers/CampaignsHelper';
import LeftColorBlockBox from '../LeftColorBlockBox/LeftColorBlockBox';
import LeftColorBlockHeadedPanel from '../LeftColorBlockBox/LeftColorBlockHeadedPanel';
import ProfilePic, { PROFILE_PIC_SIZES } from '../ProfilePic/ProfilePic';
import { AuthContext } from '../../contexts/AuthContext';
import { ReactComponent as PencilIcon } from '../../assets/icons/Pencil.svg';

const ChannelList = (props) => {
    return (
        <div className='fl-row compact'>
            {props.channels.map((channel, index) => {
                return (
                    <div><a href={`https://www.twitch.tv/${channel.twitchHandle}`} target="_blank" rel="noreferrer">{channel.twitchHandle}</a></div>
                );
            })}
        </div>
    );
}

const CampaignSummaryPanel = (props) => {
    // console.log('CampaignSummaryPanel props: ', props);

    const navigate = useNavigate();

    const [campaignContext, setCampaignContext] = useContext(CampaignContext)
    const openCampaignOverview = (e, campaignID) => {
        navigate(TOP_LEVEL_NAV_ROUTES.CAMPAIGN_OVERVIEW.replace(':id', campaignID));
    }

    const setCampaignAsStarred = (e, campaignID) => {
        e.stopPropagation();
        props.toggleCampaignAsStarred(campaignID);
    }

    const streamUrl = props.showStream ? getTwitchStreamUrl(props.showStream.twitchHandle) : '';
    const openTwitchChannel = () => {
        window.open(streamUrl, '_blank');
    }

    const status = props.showStream ? getStreamTypeDataFromDbString(props.showStream.status) : (props.campaign.statusData || getStatusForCampaign(props.campaign.streams, props.campaign.archived));
    const statusCounts = props.campaign.statusCounts || countStreamStatusTypesForCampaign(props.campaign.streams);
    // Just insert that data so we can use it for filters!
    props.campaign.statusData = status;
    props.campaign.status = status.mapToForCount;
    props.campaign.statusCounts = statusCounts;
    // console.log('Status data: ', status);

    const startTimeHms = (props.showStream && props.timezoneData) ? convertMSToHMS(props.showStream.startTime, false, props.timezoneData.offset) : null;
    const endTimeHms = (props.showStream && props.timezoneData) ? convertMSToHMS(props.showStream.endTime, false, props.timezoneData.offset) : null;

    // Add duplicate handler
    const handleDuplicate = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (props.onDuplicate) {
            props.onDuplicate(props.campaign._id);
        }
    };

    // Handle row selection
    const handleRowClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (props.onSelect) {
            props.onSelect(props.campaign._id);
        }
    };

    // Handle double click to open campaign
    const handleRowDoubleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        openCampaignOverview(e, props.campaign._id);
    };

    // Handle star click
    const handleStarClick = (e) => {
        e.stopPropagation();
        setCampaignAsStarred(e, props.campaign._id);
    };

    // Handle archive click
    const handleArchiveClick = (e) => {
        e.stopPropagation();
        if (props.archiveCampaign) {
            props.archiveCampaign(props.campaign._id);
        }
    }

    return (
        <>
        {props.listView &&
            // <LeftColorBlockBox style={'campaign_' + status.dbString} onClickHandler={(e) => { openCampaignOverview(e, props.campaign._id); }}>
                <div 
                    className={`fl-row list-view-content list-view-content-list-item cursor-pointer${props.isSelected ? ' selected' : ''}`}
                    onClick={handleRowClick}
                    onDoubleClick={handleRowDoubleClick}
                >
                    {/* <div className='tier-badge'>
                        <img src={'/assets/tier-badges/badge-fill-' + getCampaignTierDataFromDbString(props.campaign.campaignTier).imgString + '.svg'} alt="" />
                    </div> */}
                    <div className='fl-row list-view-data-block fixed-icon'>
                        { props.isStarred &&
                            IconJsxer.GetIcon(IconJsxer.ICONS.star, IconJsxer.ICON_STYLES.listIcon)
                        }
                    </div>
                    <div className='fl-row list-view-data-block wide'>
                        {props.campaign.campaignName}
                    </div>
                    <div className='fl-row list-view-data-block wide'>
                        <ProfilePic size={PROFILE_PIC_SIZES.small} className="pp-style" user={props.campaign.campaignOwnerAccountObj} />
                        {props.campaign.campaignOwnerName}
                    </div>
                    <div className='fl-row list-view-data-block wide'>
                        {props.campaign.status}
                    </div>
                    <div className='fl-row list-view-data-block wide'>
                        {props.campaign.client}
                    </div>

                    <div className='fl-row list-view-data-block narrow'>
                        {getShortDateString(new Date(props.campaign.updatedAt).getTime())}
                    </div>

                    {/* <div className='stream-count light-text'>
                        <div className='fl-row compact grow'>
                            {IconJsxer.GetIcon(IconJsxer.ICONS.liveStream, IconJsxer.ICON_STYLES.standard)}
                            <div className='grow'>
                                {statusCounts.live + statusCounts.scheduled + statusCounts.ended}
                            </div>
                        </div>
                    </div> */}

                    {/* <button className='standard-button' onClick={(e) => { openCampaignOverview(e, props.campaign._id); }}>
                        {IconJsxer.GetIcon(IconJsxer.ICONS.cog, IconJsxer.ICON_STYLES.listIcon)}
                    </button> */}
                    <div className='fl-row list-view-data-block actions'>
                        <div title="Duplicate" className='tight' onClick={handleDuplicate}>
                            <img src="/assets/icons/Files.svg" alt="Duplicate" style={{height: '1.4rem'}} />
                        </div>
                        <div title="Edit campaign details" className='tight' onClick={(e) => { openCampaignOverview(e, props.campaign._id); }}>
                            <PencilIcon className="campaign-pencil" aria-label="Edit" />
                        </div>
                        <div title="Add to starred" className="tight" onClick={handleStarClick}>
                            <img src="/assets/icons/Star.svg" alt="Star" style={{height: '1.4rem'}} />
                        </div>
                        <div title="Add to archived" className="tight" onClick={handleArchiveClick}>
                            <img src="/assets/icons/Archive.svg" alt="Archive" style={{height: '1.4rem'}} />
                        </div>
                    </div>
                </div>
            // </LeftColorBlockBox>
        }
        {!props.listView &&
            <LeftColorBlockHeadedPanel
                style={'campaign_' + status.dbString}
                className={`campaign-panel`}
                fullWidth={false}
                onClickHandler={(e) => { openCampaignOverview(e, props.campaign._id); }}
            // <HeadedPanel className={`campaign-panel${props.listView ? ' list-view' : ''}`} color={status.headedPanelColorStr}
                headingContent={
                    <>
                    {props.listView &&
                        <>
                            <div className="grow"></div>
                            <div className="icon">{IconJsxer.GetIcon(status.icon, IconJsxer.ICON_STYLES.campaignPanelTopList)}</div>
                            <div className='list-view-status'>Stream {status.displayName}</div>
                            <div className="grow"></div>
                        </>
                    }
                    {!props.listView &&
                        <div className='fl-row list-view-content'>
                            <div className="list-view-label grow">{props.campaign.campaignName}</div>
                            <div className='tier-badge'>
                                <img src={'/assets/tier-badges/badge-fill-' + getCampaignTierDataFromDbString(props.campaign.campaignTier).imgString + '.svg'} alt="" />
                            </div>
                        </div>
                    }
                    </>
                }
            >
                {props.listView &&
                    <div className='fl-column' onClick={(e) => { openCampaignOverview(e, props.campaign._id); }}>
                        <div className='fl-row'>
                            <div className='tier-badge'>
                                {console.log(getCampaignTierDataFromDbString(props.campaign.campaignTier))}
                                <img src={'/assets/tier-badges/badge-fill-' + getCampaignTierDataFromDbString(props.campaign.campaignTier).imgString + '.svg'} alt="" />
                            </div>
                            <h3>{props.campaign.campaignName}</h3>
                            <div className='grow'></div>
                            <div className="info-pill active">
                                {IconJsxer.GetIcon(IconJsxer.ICONS.liveStream, IconJsxer.ICON_STYLES.campaignPanelInfoPill)}
                                <div className="grow"></div>
                                <div>{statusCounts.live}</div>
                                <div className="grow"></div>
                                <div>Active</div>
                            </div>
                            <div className="info-pill scheduled">
                                {IconJsxer.GetIcon(IconJsxer.ICONS.scheduleNav, IconJsxer.ICON_STYLES.campaignPanelInfoPill)}
                                <div className="grow"></div>
                                <div>{statusCounts.scheduled}</div>
                                <div className="grow"></div>
                                <div>Scheduled</div>
                            </div>
                            <div className="info-pill archived">
                                {IconJsxer.GetIcon(IconJsxer.ICONS.archived, IconJsxer.ICON_STYLES.campaignPanelInfoPill)}
                                <div className="grow"></div>
                                <div>{statusCounts.ended}</div>
                                <div className="grow"></div>
                                <div>Ended</div>
                            </div>
                        </div>
                        <div className='fl-row'>
                            <p><span className="detail-label">Campaign Owner: </span><span className="detail-info-1">{props.campaign.campaignOwnerName}</span></p>
                            <p><span className="detail-label">Status: </span><span className="detail-info-1">{props.campaign.status}</span></p>
                            <p><span className="detail-label">Client: </span><span className="detail-info-1">{props.campaign.client}</span></p>
                            <p><span className="detail-label">Last Modified: </span><span className="detail-info-1">{getShortDateString(props.campaign.lastModified)}</span></p>
                            {/* <div className='grow'></div> */}
                            <div className="fl-row">
                                <button className="standard-button tight" onClick={(e) => { setCampaignAsStarred(e, props.campaign._id); }}><img src="/assets/icons/Star.svg" alt="Star" style={{height: '1.4rem'}} /></button>
                                <button disabled className="watch-btn fl-equal">Watch</button>
                            </div>
                        </div>
                    </div>
                }
                {!props.listView &&
                    <div className='fl-column grow' onClick={(e) => { openCampaignOverview(e, props.campaign._id); }}>

                        <div>
                            <p>
                                <span className="detail-label">Client: </span>
                                <span className="detail-info-1">{props.campaign.client}</span>
                            </p>


                            <p><span className="detail-label">Region: </span><span className="detail-info-1">{getRegionDataFromDbString(props.campaign.region).displayName}</span></p>
                        
                            {!props.showStream &&
                                <>
                                    <p><span className="detail-label">Campaign Owner: </span><span className="detail-info-1">{props.campaign.campaignOwner}</span></p>
                                    <p><span className="detail-label">Salesforce#: </span><span className="detail-info-1"><a href={props.campaign.sfLink} target='_blank'>{props.campaign.sfNumber}</a></span></p>
                                </>
                            }

                            <p><span className="detail-label">Created: </span><span className="detail-info-1">{getShortDateString(props.campaign.dateCreated)}</span></p>
                        </div>

                        {!props.showStream &&
                            <>
                                <div className="fl-row grow">
                                    <div className="info-pill active grow">
                                        {IconJsxer.GetIcon(IconJsxer.ICONS.liveStream, IconJsxer.ICON_STYLES.campaignPanelInfoPill)}
                                        <div className="grow"></div>
                                        <div>{statusCounts.live}</div>
                                        <div className="grow"></div>
                                        <div>Active</div>
                                    </div>
                                    <div className="info-pill scheduled grow">
                                        {IconJsxer.GetIcon(IconJsxer.ICONS.scheduleNav, IconJsxer.ICON_STYLES.campaignPanelInfoPill)}
                                        <div className="grow"></div>
                                        <div>{statusCounts.scheduled}</div>
                                        <div className="grow"></div>
                                        <div>Scheduled</div>
                                    </div>
                                    <div className="info-pill archived grow">
                                        {IconJsxer.GetIcon(IconJsxer.ICONS.archived, IconJsxer.ICON_STYLES.campaignPanelInfoPill)}
                                        <div className="grow"></div>
                                        <div>{statusCounts.ended}</div>
                                        <div className="grow"></div>
                                        <div>Ended</div>
                                    </div>
                                </div>
                            </>
                        }

                        {props.showStream &&
                        <>
                            <div className='stream-data'>
                                {props.showStream.channels && props.showStream.channels.length > 0 &&
                                    <div className="fl-row"><div>{TwitchIconSvg}</div><ChannelList channels={props.showStream.channels} /></div>
                                }
                                {/* 
                                <div className="fl-row"><div>{IconJsxer.GetIcon(IconJsxer.ICONS.scheduleNav, IconJsxer.ICON_STYLES.streamData)}</div><div>{getLongDateString(props.showStream.startTime)}</div></div>
                                <div className="fl-row"><div>{IconJsxer.GetIcon(IconJsxer.ICONS.clock, IconJsxer.ICON_STYLES.streamData)}</div><div>{getShortTimeString(props.showStream.startTime)} - {getShortTimeString(props.showStream.endTime)}</div></div> */}
                                <div className='fl-row'>
                                    <div>
                                        {IconJsxer.GetIcon(IconJsxer.ICONS.scheduleNav, IconJsxer.ICON_STYLES.streamData)}
                                    </div>
                                    <div>
                                        {getTzLongDateString(props.showStream.startTime, props.timezoneData.offset)}
                                    </div>
                                </div>
                                                        
                                <div className='fl-row'>
                                    {IconJsxer.GetIcon(IconJsxer.ICONS.clock, IconJsxer.ICON_STYLES.streamData)}
                                    {`${startTimeHms.h_str}:${startTimeHms.m_str} - ${endTimeHms.h_str}:${endTimeHms.m_str} (${props.timezoneData.label.replace('(', '').replace(')', '')})`}
                                </div>

                                <div className='fl-row'>
                                    {IconJsxer.GetIcon(IconJsxer.ICONS.clock, IconJsxer.ICON_STYLES.streamData)}
                                    {getShortDateTimeString(props.showStream.startTime, false, ', ')} - {getShortTimeString(props.showStream.endTime, false)} (Local Time)
                                </div>

                            </div>
                        </>
                        }

                        <div className="fl-row">
                            <button className="standard-button tight" onClick={(e) => { setCampaignAsStarred(e, props.campaign._id); }}><img src="/assets/icons/Star.svg" alt="Star" style={{height: '1.4rem'}} /></button>
                            {/* {<button className="standard-button tight" onClick={(e) => { openCampaignOverview(e, props.campaign._id); }}>{IconJsxer.GetIcon(IconJsxer.ICONS.cog, IconJsxer.ICON_STYLES.listIcon)}</button>} */}
                            {/*props.showStream && 
                                <button className="standard-button tight" onClick={(e) => {openTwitchChannel()}}>
                                    <div className="lcb-button-icon">
                                        {TwitchIconSvg}
                                    </div>
                                </button>
                            */}
                        </div>
                    </div>
                }
            </LeftColorBlockHeadedPanel>
        }
        </>
    );
}

export default CampaignSummaryPanel;
